import { writable } from "svelte/store";

/**
 * Svelte store to manage the muting state for autoplaying videos.
 * This is necessary due to browser restrictions on autoplaying videos with sound.
 * For more details, refer to: https://developer.chrome.com/blog/autoplay
 *
 * The 'shouldMuteVideo' store is initialized with a default value of 'true' to enable video autoplay.
 * When the user unmutes the video, update 'shouldMuteVideo' to 'false'.
 * This store is designed to be used in multiple instances of the VideoItem component.
 */
const shouldMuteVideo = writable(true);

export { shouldMuteVideo };
